import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseService } from '@easy-lib/modules/shared/services/Base/base.service';
import { SettingStore } from '@easy-lib/state/setting/setting.store';

const location = 'tracker';

@Injectable({
	providedIn: 'root'
})
export class TrackerService extends BaseService {
	readyToSave = true;
	isTrackingActive = false;
	timerValue: any = {};
	timeTracker: any = {};
	extraData: any = {};
	// #region "Http paths"
	private get trackerUrl(): string {
		return this.environment.setting.applogApiPath + 'tracker';
	}
	constructor(private settingStore: SettingStore) {
		super();
		this.isTrackingActive = this.environment.setting.dataTracking;
		this.settingStore.setting$.subscribe((result: any) => {
			if (result) this.isTrackingActive = this.environment.setting.dataTracking && result.dataTracker;
		});

		setInterval(() => {
			if (this.readyToSave) {
				const tracks: ITrack[] = JSON.parse(localStorage.getItem(location)) || [];
				if (tracks.length > 0) this.insertTrackData(tracks);
			}
		}, 180000);
	}

	insertTrackData(tracks: ITrack[]) {
		if (!this.isTrackingActive) return;
		this.httpService.post(this.trackerUrl, { body: { tracks: tracks } }).subscribe(() => {
			localStorage.removeItem(location);
		});
	}
	counter(trackKey: string, id: string, param?: any) {
		if (!this.isTrackingActive) return;
		const track: ITrack = {
			constantName: trackKey,
			TrackingId: id,
			startDate: this.getDate(),
			endDate: this.getDate(),
			eventType: EventType.Counter,
			value: 1,
			extraData: JSON.stringify(param)
		};
		this.setLocalStorage(track).subscribe();
	}

	startTimer(trackKey: string, id: string, param?: any) {
		if (!this.isTrackingActive) return;
		//...
		this.timerValue[trackKey + id] = 0;
		this.extraData[trackKey + id] = param;
		this.timeTracker[trackKey + id] = setInterval(() => {
			this.timerValue[trackKey + id]++;
		}, 1000);
	}

	endTimer(trackKey: string, id: string) {
		this.readyToSave = false;
		if (!this.isTrackingActive) return;
		if (!this.timeTracker[trackKey + id]) return;
		clearInterval(this.timeTracker[trackKey + id]);
		const track: ITrack = {
			constantName: trackKey,
			TrackingId: id,
			startDate: this.getDate(),
			endDate: this.getDate(),
			eventType: EventType.Timer,
			value: this.timerValue[trackKey + id],
			extraData: JSON.stringify(this.extraData[trackKey + id])
		};
		this.setLocalStorage(track).subscribe();
		this.readyToSave = true;
	}

	private setLocalStorage(track: ITrack): Observable<boolean> {
		const tracks: ITrack[] = JSON.parse(localStorage.getItem(location)) || [];
		const index = tracks.findIndex(
			t =>
				t.constantName == track.constantName &&
				t.TrackingId == track.TrackingId &&
				t.eventType == track.eventType
		);
		if (index >= 0) {
			tracks[index].value += track.value;
			tracks[index].endDate = this.getDate();
		} else {
			tracks.push(track);
		}
		localStorage.setItem(location, JSON.stringify(tracks));

		return of(true);
	}

	getDate(date?: Date): string {
		if (date) return new Date(date.getMilliseconds() - date.getTimezoneOffset() * 60000).toISOString().slice(0, -1);
		else return new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, -1);
	}
}

export interface ITrack {
	constantName: string;
	TrackingId: string;
	startDate?: string;
	endDate?: string;
	eventType: EventType;
	value: number;
	extraData?: string;
	customerIsin?: string;
}

export enum EventType {
	Counter = 1,
	Timer = 2
}

export enum TrackKey {
	symbol = 'symbol'
}
